module.exports = __webpack_public_path__ + "img/ExitusC_colors.994a6d19.png";